import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Copy, Loader2 } from "lucide-react";

export function CloneToDateDialog({ open, targetDate, channelId, onClose, onCloned }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setReason(""); }, [open]);
  if (!open || !targetDate) return null;

  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post("/schedule/clone-to-date", {
        channel_id: channelId,
        target_date: targetDate,
        reason: reason || null,
      });
      toast.success(`Exception created on ${targetDate} · ${r.data.cloned} items cloned`);
      if (r.data.auto_published) {
        toast.info(`Publishing ${r.data.auto_published} asset${r.data.auto_published === 1 ? "" : "s"} to CDN…`, {
          description: "Today's tile will flip to Cloudflare edge in a few seconds",
        });
      }
      onCloned();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Clone failed"); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-card border-border rounded-sm max-w-md" data-testid="clone-date-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Copy className="w-4 h-4 text-fuchsia-400" /> New date exception
          </DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground">
            Creates an editable copy of the weekly template for <b>{targetDate}</b>. Overrides ONLY this date and can be reverted any time.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="text-[10px] uppercase tracking-widest text-muted-foreground">Reason (optional)</Label>
          <Input
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Christmas Special · F1 Race · Election Coverage"
            className="mt-1 rounded-sm"
            data-testid="clone-reason"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" className="rounded-sm h-8 text-xs" onClick={onClose}>Cancel</Button>
          <Button size="sm" className="rounded-sm h-8 text-xs tenant-btn" onClick={submit} disabled={busy} data-testid="clone-submit">
            {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Copy className="w-3.5 h-3.5 mr-1" />} Create exception
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
